<template>
  <div>
    <v-row v-if="loading">
      <v-col>
        <v-progress-circular indeterminate />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-card
          flat
          class="px-4 py-3"
          height="100%"
          :key="reRender"
          :class="!isEditCard1 ? 'mouse-cursor' : ''"
        >
          <div class="text-start">
            <v-row class="py-3">
              <v-col>
                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{
                      $t("user.profile.companyProfile.accountName")
                    }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.accountName"
                      :isEdit="isEditCard1"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{
                      $t("user.profile.companyProfile.bankName")
                    }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2 v-model="card1.bankName" :isEdit="isEditCard1" />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{
                      $t("user.profile.companyProfile.accountNumber")
                    }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.accountNumber"
                      :isEdit="isEditCard1"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{
                      $t("user.profile.companyProfile.branchName")
                    }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2 v-model="card1.branch" :isEdit="isEditCard1" />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.profile.companyProfile.ifsc") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2 v-model="card1.ifsc" :isEdit="isEditCard1" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <float-btn
            v-if="!loading"
            :isEdit="isEditCard1"
            @save="saveCard1Items"
            @edit="isEditCard1 = true"
            :bottom="true"
            :align="'right'"
            :loading="savingData1"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarError" timeout="3000" color="error">
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="
            snackbarError = false;
            snackbarErrorMessage = null;
          "
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Editable2 from "../../../core-module/components/ContentEditable2.vue";
import FloatBtn from "../employee-profile/FloatBtn.vue";

import { createOrUpdateSubscriberProfile } from "../../methods/createOrUpdateSubscriberProfile";

export default {
  components: {
    Editable2,
    FloatBtn,
  },
  props: {
    companyData: {
      type: Object,
      default: () => {},
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      snackbarError: false,
      snackbarErrorMessage: null,
      card1: {
        accountName: "",
        bankName: "",
        accountNumber: "",
        branch: "",
        ifsc: "",
      },
      companyProfile: null,
      savingData1: false,
      isEditCard1: false,
      reRender: 0,
    };
  },

  watch: {
    companyData: {
      immediate: true,
      handler() {
        this.companyProfile = this.companyData ? this.companyData : null;
        this.resetFormData();
      },
      deep: true,
    },
  },
  methods: {
    resetFormData() {
      this.card1.accountName = this.companyProfile?.bankDetails?.accountName;
      this.card1.bankName = this.companyProfile?.bankDetails?.bankName;
      this.card1.accountNumber =
        this.companyProfile?.bankDetails?.accountNumber;
      this.card1.branch = this.companyProfile?.bankDetails?.branch;
      this.card1.ifsc = this.companyProfile?.bankDetails?.ifsc;

      this.reRender++;
    },

    async saveCard1Items() {
      this.snackbarErrorMessage = null;

      this.savingData1 = true;
      this.isEditCard1 = false;
      let saveData = {
        bankDetails: {
          accountName: this.card1.accountName ? this.card1.accountName : null,
          bankName: this.card1.bankName ? this.card1.bankName : null,
          accountNumber: this.card1.accountNumber
            ? this.card1.accountNumber
            : null,
          branch: this.card1.branch ? this.card1.branch : null,
          ifsc: this.card1.ifsc ? this.card1.ifsc : null,
        },
      };

      this.createOrUpdateProfile(saveData).then(response => {
        if (response.error) {
          this.$emit("onError");
          this.resetFormData();
        }

        this.savingData1 = false;
      });
    },

    createOrUpdateProfile(data) {
      return createOrUpdateSubscriberProfile(data);
    },
  },
};
</script>

<style scoped>
.hide-underline >>> .v-input__slot::before {
  border-style: none !important;
}
.hide-underline >>> .v-input__slot::after {
  border-style: none !important;
}
</style>
